import axios from 'axios';
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: false,
})

export default class ApiClient {
  static async load(snippet) {
    const endpoint = process.env.NODE_ENV !== 'development'
      ? 'https://api.tinkerwell.app/api/snippets'
      : 'http://tinkerwell-api.test/api/snippets';

    try {
      const {data} = await axios.get(`${endpoint}/${snippet}`)

      return data;
    } catch (err) {
      Toast.fire({
        icon: 'error',
        title: 'Something went wrong while loading the snippet.'
      });

      return null;
    }
  }

  static async delete(snippet, deletePassword) {
    const endpoint = process.env.NODE_ENV !== 'development'
      ? 'https://api.tinkerwell.app/api/snippets'
      : 'http://tinkerwell-api.test/api/snippets';

    try {
      const {data} = await axios.delete(`${endpoint}/${snippet}`, {
        data : {deletePassword}
      })

      Toast.fire({
        icon: 'success',
        title: 'Your snippet was deleted.'
      })

      return data;
    } catch (err) {
      Toast.fire({
        icon: 'error',
        title: 'Unable to delete your snippet. Check the password.'
      });

      return null;
    }
  }

  static async save(deletePassword, mode, cliCode, controllerCode, viewCode, output) {
    const endpoint = process.env.NODE_ENV !== 'development'
      ? 'https://api.tinkerwell.app/api/snippets'
      : 'http://tinkerwell-api.test/api/snippets';

    try {
      const {data} = await axios.post(endpoint, {
        deletePassword,
        mode,
        cliCode,
        controllerCode,
        viewCode,
        output
      })

      Toast.fire({
        icon: 'success',
        title: 'Your snippet was saved.'
      })

      return data.hash;
    } catch (err) {
      Toast.fire({
        icon: 'error',
        title: 'Something went wrong while saving your snippet.'
      });

      return null;
    }
  }
}
